var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "w-100 confirmation-page" },
    [
      _c(
        "div",
        {
          staticClass: "container-fluid fixed-top w-100 px-0",
          attrs: { id: "nav-info", role: "navigation" }
        },
        [_c("interview-navi", { attrs: { navData: _vm.pageData } })],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "quote-panel-open": _vm.quotePanelStatus,
            "quote-panel-close": !_vm.quotePanelStatus
          },
          attrs: { role: "main" }
        },
        [
          _c(
            "div",
            {
              staticClass: "row no-gutters mx-0",
              staticStyle: { "margin-top": "-1rem" }
            },
            [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-12 pt-3 pb-2 mb-3 text-center text-white bg-success-blue"
                      },
                      [
                        _c("h1", { staticClass: "title-banner" }, [
                          _vm._v(_vm._s(_vm.pageTitle))
                        ])
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.dataTree, function(group, i) {
                    return group
                      ? _c(
                          "div",
                          { key: i, staticClass: "my-3" },
                          [
                            _c("form-sections", {
                              attrs: {
                                group: group,
                                i: i,
                                pageData: _vm.pageData
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.footerNote()
            ? _c(
                "div",
                { staticClass: "d-flex justify-content-center mx-auto mt-3" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "alert alert-primary my-0 py-2 w-50",
                      attrs: { role: "note" }
                    },
                    [
                      _c("div", { staticClass: "row no-gutters" }, [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col d-inline-block my-auto smaller-font-content"
                          },
                          [_vm._v(_vm._s(_vm.footerNote()))]
                        )
                      ])
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c("dev-auto-fill", { attrs: { pageData: _vm.pageData } }),
      _vm._v(" "),
      _vm.$store.state.buttonState.quoteSummaryData &&
      _vm.$store.state.buttonState.quoteSummaryData.quote_status === "Bound"
        ? _c("form-alerts", {
            class: {
              "policy-bound-alert": true,
              "margin-25": _vm.quotePanelStatus
            },
            attrs: { pageData: _vm.policyBindError }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "d-inline-block pr-2 my-auto" }, [
      _c("img", {
        attrs: {
          width: "25px",
          height: "25px",
          src: require("../../../../assets/info-circle-blue.svg"),
          alt: "info"
        }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9f18bb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9f18bb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/Auto/RC2/Confirmation.vue
// module id = null
// module chunks = 